import React from 'react';
import clsx from 'clsx';
import styles from './Divider.module.scss';

export type DividerProps = {
  className?: string;
  as?: 'hr' | 'div';
};

const Divider: React.FC<DividerProps> = ({ className, as = 'div' }) => {
  const Comp = as as any;
  return (
    <Comp
      className={clsx(styles.divider, className)}
      aria-hidden='true'
    />
  );
};

export default Divider;
